export default "__VITE_PUBLIC_ASSET__15bb1602__"